module.exports = __webpack_public_path__ + "static/img/login_desc.5fbb5344.png";